/**
 * Framer-motion port of the hub's `.hub-panel-enter` choreography
 * (see `src/index.css`). The arena hub settles its content chunks in
 * with a short fade-rise stagger; every sibling top-level screen reuses
 * the exact same curve, distance and step here so navigating around the
 * arena reads as one continuous motion language instead of six
 * differently-timed entrances.
 *
 * Deliberately uses motion's `y` shorthand rather than a full
 * `transform` string. A resting `transform: translateY(0)` registers the
 * element as a Backdrop Root, which permanently blinds any descendant's
 * `backdrop-filter`. The same trap the hub CSS documents around
 * `animation-fill-mode`. Motion's transform builder collapses a
 * zero-valued `y` back to `transform: none`, so the blur survives once
 * the entrance finishes.
 */

const ENTER_EASE = [0.2, 0, 0, 1];
const ENTER_DURATION = 0.38;
const ENTER_STAGGER = 0.07;
const ENTER_RISE = '0.75cqw';

/**
 * Motion props for one chunk of a screen's entrance.
 *
 * @param {number} tier 1-based stagger position; tier 1 starts immediately,
 *   each subsequent tier is offset by one 70ms step.
 * @param {boolean} play Set false to hold the chunk at its pre-entrance state.
 *   A screen whose content is expensive to warm up (WebGL foil surfaces, card
 *   art) mounts hidden, does that work, and flips this true once it is ready.
 *   so the entrance plays over warm content instead of competing with shader
 *   compiles and texture uploads for the same frames.
 */
export function screenPanel(tier = 1, play = true) {
  return {
    initial: { opacity: 0, y: ENTER_RISE },
    animate: play ? { opacity: 1, y: '0cqw' } : { opacity: 0, y: ENTER_RISE },
    transition: {
      duration: ENTER_DURATION,
      ease: ENTER_EASE,
      delay: (tier - 1) * ENTER_STAGGER,
    },
  };
}
